import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  // The check is synchronous (it only reads the token from storage), so the
  // answer is known on the very first render. Starting at `isLoading: true`
  // painted a "Checking authentication…" spinner for a frame on every arrival
  // before the effect below corrected it — a visible flicker after sign-in.
  const initiallyAuthed = authService.isAuthenticated();
  const [isAuthenticated, setIsAuthenticated] = useState(initiallyAuthed);
  const [isLoading, setIsLoading] = useState(!initiallyAuthed);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if token exists - if it does, allow access
        // Token verification will happen on actual API calls via interceptors
        if (authService.isAuthenticated()) {
          setIsAuthenticated(true);
          setIsLoading(false);
          return;
        }

        // No token - not authenticated
        setIsAuthenticated(false);
        setIsLoading(false);
      } catch (error) {
        console.error('Authentication check failed:', error);
        setIsAuthenticated(false);
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    // Show loading spinner while checking authentication
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <div style={{ fontSize: '18px', color: '#666' }}>Checking authentication...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/" replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute; 